import { DjangoTimeStamped, TimeStamped } from '../django';
import { applyTimezone, parseDate } from '../helpers/date';
import { EMPLOYEE_DATA_FILE_HISTORY_STATUS } from './data-file-history-status/enum';
import { EmployeeDataFileHistory } from './employee-data-file-history.model';

export class EmployeesDataFileHistory implements TimeStamped {
  id: string;
  employeesDataFile: EmployeeDataFileHistory;
  uploaderUser: { fullName: string };
  uploaderEmail: string;
  status: EMPLOYEE_DATA_FILE_HISTORY_STATUS;
  created: Date;
  modified: Date;

  constructor(data: EmployeesDataFileHistory | DjangoEmployeesDataFileHistory) {
    bindConstructorDataToInstance(this, data);
  }
}

function bindConstructorDataToInstance(
  instance: EmployeesDataFileHistory,
  data: EmployeesDataFileHistory | DjangoEmployeesDataFileHistory,
) {
  const jsData = bindDjangoPropsToJs(data);
  instance.id = jsData.id;
  instance.employeesDataFile = jsData.employeesDataFile;
  instance.uploaderUser = jsData.uploaderUser;
  instance.uploaderEmail = jsData.uploaderEmail;
  instance.status = jsData.status;
  instance.created = applyTimezone(parseDate(jsData.created), 0);
  instance.modified = applyTimezone(parseDate(jsData.modified), 0);
}

function bindDjangoPropsToJs(data: EmployeesDataFileHistory | DjangoEmployeesDataFileHistory) {
  const djangoData = data as DjangoEmployeesDataFileHistory;
  const jsData = data as EmployeesDataFileHistory;
  return {
    id: djangoData.id || jsData.id,
    employeesDataFile: parseEmployeeData(djangoData.employees_data_file),
    uploaderUser: parseUploadUser(djangoData.uploader_user),
    uploaderEmail: djangoData.uploader_email || jsData.uploaderEmail,
    status: djangoData.status || jsData.status,
    created: djangoData.created || jsData.created,
    modified: djangoData.modified || jsData.modified,
  };
}

function parseUploadUser(uploder: any) {
  const data: any = {};
  data.fullName = uploder?.full_name || undefined;
  return data;
}

function parseEmployeeData(employeeDataFile: any) {
  const data: any = {};
  data.fileName = employeeDataFile?.filename || undefined;
  data.id = employeeDataFile?.id || undefined;
  data.employers = employeeDataFile.employers || undefined;
  return data;
}

export interface DjangoEmployeesDataFileHistory extends DjangoTimeStamped {
  uploader_user: { full_name: string };
  employees_data_file: DjangoEmployeesDataFileHistory;
  id: string;
  uploader_email: string;
  status: EMPLOYEE_DATA_FILE_HISTORY_STATUS;
  created?: string;
  modified?: string;
}
